import {NewSubAccount} from '@/subaccount/types/SubAccount'
import {ContactInfo} from '@/subaccount/types/ContactInfo'
import {Address} from '@/subaccount/types/Address'

export const ensureValidNewSubAccount = (subAccount: any) => {
    const payload = {
        ...subAccount
    }
    payload.contactInfo = ensureValidContactInfo(payload)
    payload.address = ensureValidAddress(payload)
    // TODO could we make input fields emit undefined instead of empty string?
    if (payload.bic === '') {
        delete payload.bic
    }
    if (payload.bban === '') {
        delete payload.bban
    }
    if (payload.iban === '') {
        delete payload.iban
    }
    return payload
}

const ensureValidContactInfo = (subAccount_: NewSubAccount) => {
    const subAccount = {...subAccount_}
    if (!subAccount.contactInfo) return
    const contactInfo: ContactInfo = subAccount.contactInfo

    if (!contactInfo.name && !contactInfo.email && !contactInfo.phoneNumber) {
        return
    }
    return contactInfo
}

const ensureValidAddress = (subAccount_: NewSubAccount): Address | undefined => {
    const subAccount = {...subAccount_}
    if (!subAccount.address) return

    const address: Address = subAccount.address

    if (!address.addressLine && !address.postalCode && !address.postalLocation && !address.countryCode) {
        return
    }

    return removeEmptyStringValuesFromRecord(subAccount.address) as Address
}

const removeEmptyStringValuesFromRecord = (obj: Record<any, String>): Record<any, String> => {
    const newObj = {...obj}
    for (const key in newObj) {
        const value = newObj[key]
        if (value === '') {
            delete newObj[key]
        }
    }
    return newObj
}
